import type { OutageEvent } from '../../../types/outage';
import { buildStormSummary } from './stormSummary';
import './StormBanner.css';

interface StormBannerProps {
  event: OutageEvent;
  totalCustomersOut: number;
  communitiesAffected: number;
}

export function StormBanner({ event, totalCustomersOut, communitiesAffected }: StormBannerProps) {
  const s = buildStormSummary(
    event,
    { customersOut: totalCustomersOut, communities: communitiesAffected },
    new Date(),
  );

  return (
    <div className="StormBanner" role="status">
      <span className="StormBanner-title">Active storm event</span>
      <span className="StormBanner-detail">started {s.startedAgo}</span>
      <span className="StormBanner-detail">{s.nowOut.toLocaleString()} out now</span>
      <span className="StormBanner-detail">peaked {s.peakOut.toLocaleString()}</span>
      <span className="StormBanner-detail">{s.communities} communities</span>
    </div>
  );
}
